module.exports = __webpack_public_path__ + "img/fashion_87.8a011a38.jpg";